<script>
// Hero image carousel — manual navigation only (no autoplay).
// Swipe on touch devices, arrow buttons / dots on desktop.
// Curated from the real portfolio photos in src/assets/images/portfolio -
// swap any of these out any time by pointing at a different file there.
const images = [
	{
		src: require('@/assets/images/portfolio/racecar/racecar-07.jpg'),
		alt: 'IndyCar livery wrap',
	},
	{
		src: require('@/assets/images/portfolio/flat/flat-02.jpg'),
		alt: 'Nashville Sounds ballpark seating graphics',
	},
	{
		src: require('@/assets/images/portfolio/racecar/racecar-01.jpg'),
		alt: 'Patriotic race truck wrap',
	},
	{
		src: require('@/assets/images/portfolio/commercial/commercial-03.jpg'),
		alt: 'Gigis wrap',
	},
	{
		src: require('@/assets/images/portfolio/flat/flat-17.jpg'),
		alt: 'Nashville Palace wall mural graphics',
	},
	{
		src: require('@/assets/images/portfolio/commercial/commercial-06.jpg'),
		alt: 'Fleet van wrap',
	},
	{
		src: require('@/assets/images/portfolio/flat/flat-07.jpg'),
		alt: 'Storefront graphics',
	},
	{
		src: require('@/assets/images/portfolio/racecar/racecar-15.jpg'),
		alt: 'Custom color race car wrap',
	},
	{
		src: require('@/assets/images/portfolio/flat/flat-22.jpg'),
		alt: 'Venue floor graphics',
	},
];

const SWIPE_THRESHOLD = 40; // min px of horizontal travel to count as a swipe

export default {
	data: () => {
		return {
			images,
			activeIndex: 0,
			touchStartX: null,
		};
	},
	methods: {
		prev() {
			if (this.activeIndex > 0) this.activeIndex--;
		},
		next() {
			if (this.activeIndex < this.images.length - 1) this.activeIndex++;
		},
		goTo(index) {
			this.activeIndex = index;
		},
		onTouchStart(event) {
			this.touchStartX = event.changedTouches[0].clientX;
		},
		onTouchEnd(event) {
			if (this.touchStartX === null) return;
			const dx = event.changedTouches[0].clientX - this.touchStartX;
			if (dx <= -SWIPE_THRESHOLD) this.next();
			else if (dx >= SWIPE_THRESHOLD) this.prev();
			this.touchStartX = null;
		},
	},
};
</script>

<template>
	<div class="w-full max-w-[900px]">
		<div
			class="relative w-full max-w-[900px] overflow-hidden clip-corner shadow-glow-lg border border-ternary-dark"
		>
			<!-- Sliding track -->
			<div
				class="flex w-full transition-transform duration-500 ease-out"
				:style="{ transform: `translateX(-${activeIndex * 100}%)` }"
				@touchstart.passive="onTouchStart"
				@touchend.passive="onTouchEnd"
			>
				<img
					v-for="image in images"
					:key="image.src"
					:src="image.src"
					:alt="image.alt"
					class="w-full shrink-0 h-[380px] sm:h-[460px] object-cover select-none"
					draggable="false"
				/>
			</div>

			<!-- Previous -->
			<button
				v-show="activeIndex > 0"
				@click="prev"
				class="absolute left-3 top-1/2 -translate-y-1/2 p-2 sm:p-3 clip-corner-sm bg-secondary-dark bg-opacity-80 border border-ternary-dark text-primary-light hover:text-brand-500 hover:border-brand-500 duration-300"
				aria-label="Previous photo"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="w-5 h-5 sm:w-6 sm:h-6"
				>
					<polyline points="15 18 9 12 15 6"></polyline>
				</svg>
			</button>

			<!-- Next -->
			<button
				v-show="activeIndex < images.length - 1"
				@click="next"
				class="absolute right-3 top-1/2 -translate-y-1/2 p-2 sm:p-3 clip-corner-sm bg-secondary-dark bg-opacity-80 border border-ternary-dark text-primary-light hover:text-brand-500 hover:border-brand-500 duration-300"
				aria-label="Next photo"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="w-5 h-5 sm:w-6 sm:h-6"
				>
					<polyline points="9 18 15 12 9 6"></polyline>
				</svg>
			</button>
		</div>

		<!-- Slide indicators -->
		<div class="flex justify-center gap-2 mt-4">
			<button
				v-for="(image, index) in images"
				:key="image.src"
				@click="goTo(index)"
				class="h-1.5 rounded-full duration-300"
				:class="
					index === activeIndex
						? 'w-6 bg-brand-500'
						: 'w-1.5 bg-ternary-dark hover:bg-brand-800'
				"
				:aria-label="`Show photo ${index + 1}`"
			></button>
		</div>
	</div>
</template>

<style scoped></style>
